import type { UserAvatar } from '../../api/people';
import { uiText } from '../../i18n';
import { studioApi, type StudioApp } from '../studio/studio-api';
import { useStudioDocument } from '../studio/use-studio-document';
import { VideoOrderForm } from './VideoOrderForm';
import { videoPolicy } from './video-model';
/** Открывается только продуктовый экран с полной опубликованной политикой. */
export function VideoEntryForm(props: {
  app: StudioApp;
  avatar: UserAvatar | null;
  initialInputs?: Record<string, unknown>;
  headerActive?: boolean;
}) {
  const probe = useStudioDocument(signal => studioApi.form(props.app.id, signal), `video-entry:${props.app.id}`);
  if (probe.loading) return <p role="status">{uiText('Загружаем…')}</p>;
  if (probe.error || !probe.data || probe.data.app_id !== props.app.id || probe.data.screen !== 'video')
    return (
      <p role="alert">
        {uiText('Этот режим видео пока недоступен')}{' '}
        <button type="button" onClick={probe.reload}>
          {uiText('Повторить')}
        </button>
      </p>
    );
  return videoPolicy(probe.data) ? <VideoOrderForm {...props} /> : <p role="alert">{uiText('Этот режим видео пока недоступен')}</p>;
}
